import React from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import Slider from '../../../../../components/utils/Slider';
import Img from '../../../../../components/Img';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { RETURN_REASON_TYPE_TEXT } from '../../../../../constants/service/app/orderConstants';
import { setDash, setPhoneFormat } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import './ReturnReasonModal.scss';

const ReturnReasonModal = (props) => {
  const { isOpen, data, closeModal } = props;
  const { reasonType, buyerName, buyerAccount, date, orderItemId, buyerPhone, productName, reason, attachments } = data;

  /**
   *  사진이 없을때는 적용하지 않고 사진이 있을때는 690 으로 한다
   */
  const modalHeight = attachments.length > 0 ? 690 : '';

  return (
    <Modal
      title={`${RETURN_REASON_TYPE_TEXT[reasonType]}사유`}
      isOpen={isOpen}
      width={600}
      height={modalHeight}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="return-reason-modal-wrap">
        <div className="return-reason-info">
          <InfoTable>
            <thead>
              <tr>
                <th>작성자</th>
                <th>작성자ID</th>
                <th>{RETURN_REASON_TYPE_TEXT[reasonType]}일시</th>
                <th>상품주문번호</th>
                <th>구매자 연락처</th>
                <th>상품명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tc">{setDash(buyerName)}</td>
                <td className="tc">{buyerAccount}</td>
                <td className="tc">{setDateFormat(date, DATE_FORMAT.YMD_DASH_FORMAT)}</td>
                <td className="tc">{orderItemId}</td>
                <td className="tc">{setPhoneFormat(buyerPhone)}</td>
                <td className="tc">{productName}</td>
              </tr>
            </tbody>
          </InfoTable>
        </div>

        <div className="reason">
          <div className="label">{RETURN_REASON_TYPE_TEXT[reasonType]}사유</div>
          <div className="content">{reason}</div>
          {!attachments.length ? <div className="line"></div> : null}
        </div>

        <div className="img-area">
          {attachments.length > 0 ? <Slider list={attachments} item={(url) => <Img src={url} />} /> : undefined}
        </div>
      </div>
    </Modal>
  );
};

export default ReturnReasonModal;
